import { createRouter, createWebHistory } from 'vue-router'
import StartupView from '../views/StartupView.vue'
import ProjectViewer from '../views/ProjectViewer.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'startup',
      component: StartupView,
    },
    {
      path: '/workspace',
      name: 'workspace',
      component: ProjectViewer,
    },
  ],
})

export default router
